export { default as ProductCard } from "./ProductCard";
